import { salt } from '../@helpers';
import ButtonGroup from './ButtonGroup';
import GrowthCalculator from './GrowthCalculator';
import Heading from './Heading';
import HorizontalRule from './HorizontalRule';
import IconBlocks from './IconBlocks';
import PageHeader from './PageHeader';
import PageHero from './PageHero';
import PageSection from './PageSection';
import Paragraph from './Paragraph';
import PromoPanel from './PromoPanel';
import React, { Component, Fragment } from 'react';

export default class extends Component {
  render() {
    const components = {
      'pb_page_hero': PageHero,
      'pb_page_header': PageHeader,
      'pb_promotional_panel': PromoPanel,
      'pb_page_content_panel': PageSection,
      'pb_icon_blocks': IconBlocks,
      'pb_heading': Heading,
      'pb_paragraph': Paragraph,
      'pb_button_group': ButtonGroup,
      'pb_separator': HorizontalRule,
      'pb_growth_calculator': GrowthCalculator,
    }

    const { blocks } = this.props;
    const hasData = blocks && blocks.length > 0;
    return (
      <Fragment>
        {hasData && blocks.map(block => {
          const SpecificComponent = components[block.acf_fc_layout];
          return SpecificComponent && <SpecificComponent data={block} key={salt()} />;
        })}
      </Fragment>
    )
  }
}